import { useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useCustomerAuth } from "../../context/CustomerAuthContext";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Card } from "../../components/ui/card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";

// iter135 — Google Auth (Emergent) + Guest + Email/Şifre
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function GoogleButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="ca-google-btn"
      className="w-full flex items-center justify-center gap-2.5 py-2.5 rounded-md border border-zinc-300 hover:border-zinc-400 hover:bg-zinc-50 text-sm font-medium text-zinc-800 transition-colors">
      <svg width="18" height="18" viewBox="0 0 48 48">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 15.4 19 12 24 12c3.1 0 5.9 1.2 8 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.4 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 34.9 26.8 36 24 36c-5.3 0-9.7-3.3-11.3-8l-6.5 5C9.5 39.5 16.2 44 24 44z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.2-4 5.6l6.2 5.2c-.4.4 6.6-4.8 6.6-14.8 0-1.3-.2-2.4-.5-3.5z"/>
      </svg>
      Google ile devam et
    </button>
  );
}

export default function CustomerAuth() {
  const { customer, login, register, loginWithGoogle } = useCustomerAuth();
  const [params] = useSearchParams();
  const redirect = params.get("redirect");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);

  if (customer) return <Navigate to={redirect ? `/${redirect}` : "/hesap"} replace/>;

  const submit = async (mode) => {
    setLoading(true);
    if (mode === "login") await login(email, password);
    else await register(name, email, password, phone);
    setLoading(false);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-12">
      <Card className="p-8 border-zinc-200">
        <h1 className="font-display font-bold text-2xl text-zinc-900 mb-2">Müşteri Girişi</h1>
        <p className="text-sm text-zinc-500 mb-6">Alışverişe devam etmek için giriş yapın veya yeni hesap açın.</p>

        <GoogleButton onClick={loginWithGoogle}/>
        <div className="my-5 flex items-center gap-3 text-xs text-zinc-400">
          <span className="flex-1 h-px bg-zinc-200"/>veya e-posta ile<span className="flex-1 h-px bg-zinc-200"/>
        </div>

        <Tabs defaultValue="login">
          <TabsList className="grid grid-cols-2 w-full mb-6">
            <TabsTrigger value="login" data-testid="ca-login-tab">Giriş</TabsTrigger>
            <TabsTrigger value="register" data-testid="ca-register-tab">Kayıt</TabsTrigger>
          </TabsList>
          <TabsContent value="login" className="space-y-4">
            <div><Label>E-posta</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="ca-login-email"/></div>
            <div><Label>Şifre</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="ca-login-pass"/></div>
            <Button disabled={loading} onClick={() => submit("login")} className="w-full bg-primary hover:bg-primary/90" data-testid="ca-login-submit">{loading ? "..." : "Giriş Yap"}</Button>
          </TabsContent>
          <TabsContent value="register" className="space-y-4">
            <div><Label>Ad Soyad</Label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="ca-reg-name"/></div>
            <div><Label>E-posta</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="ca-reg-email"/></div>
            <div><Label>Telefon</Label><Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+90..."/></div>
            <div><Label>Şifre</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="ca-reg-pass"/></div>
            <Button disabled={loading} onClick={() => submit("register")} className="w-full bg-primary hover:bg-primary/90" data-testid="ca-reg-submit">{loading ? "..." : "Kayıt Ol"}</Button>
          </TabsContent>
        </Tabs>

        <div className="mt-6 pt-5 border-t border-zinc-100 text-center text-xs text-zinc-500">
          Kayıt olmadan sipariş vermek ister misiniz? <a href="/sepet" className="text-primary font-semibold hover:underline">Misafir olarak ödeme yap</a>
        </div>
      </Card>
    </div>
  );
}
